import { Component,OnInit  } from '@angular/core';
import { Router, ActivatedRoute } from '@angular/router';
import { Result } from '../../servicios/servers.service';
import { AlertService } from "../../servicios/alert.service";
import { PersonaService } from '../../servicios/persona.service';
import { loading_show, loading_hide } from '../../app.helpers';
import { Usuario } from '../../models/Usuario';

declare var jQuery:any;

@Component({
    selector: 'recuperarClave',
    templateUrl: 'recuperarClave.template.html'
})
export class recuperarClaveComponent implements OnInit {

    model: any = {};
    loading = false;
    returnUrl: string;
 
    constructor(
        private route: ActivatedRoute,
        private router: Router,
        private PersonaService: PersonaService,
        private alertService: AlertService
    ) {  }

    ngOnInit() {

    }

    enviarCorreo() {
        
        this.loading = true;

        var object = {
            email: this.model.email
        };

        this.PersonaService.enviarEmail(object,(data: any) => {

            
            if (data.isOk) {

                if(data.Mensaje == "ok"){
                    this.alertService.success("Mensaje Enviado Correctamente");
                    this.model = {};
    
                }else{
                    this.alertService.error(data.Mensaje);
                }
                

            }else{
                this.alertService.error("Error desconocido");
            }

            this.loading = false;            

        });
    }

 }


// WEBPACK FOOTER //
// ./src/app/views/recuperarClave/recuperarClave.component.ts